import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { useSettings } from 'app/main/components';
import { ViewTable } from 'app/main/components/page-layouts';
import { type MiddlewhereFilter } from 'app/main/components/filter/FilterItemManager';

import useMailsTableColumns from 'app/main/submodules/mails/MailsTableColumns';

interface DemsRecipientsAddResultDialogProps {
	defaultFilters?: MiddlewhereFilter[];
	defaultQuery?: any;
	addRows: VoidFunction;
	goBack: VoidFunction;
}

export default function DemsRecipientsAddResultDialog(props: DemsRecipientsAddResultDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const [refresh, setRefresh] = React.useState(false);
	const updateRefresh = () => setRefresh(state => !state);

	const columns = useMailsTableColumns({ dispatch, t, updateRefresh });

	return (
		<>
			<DialogTitle>{t('DEMS_DIALOG_TITLE_ADD_RESULT')}</DialogTitle>
			<DialogContent>
				<ViewTable
					module="mails"
					columns={columns}
					defaultFilters={props.defaultFilters}
					defaultQuery={props.defaultQuery}
					refresh={refresh}
					updateRefresh={updateRefresh}
					showFilters={false}
					showExportButton={false}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.goBack}>{t('DIALOG_ACTION_BACK')}</Button>
				<Button color="secondary" onClick={props.addRows}>
					{t('DIALOG_ACTION_CONFIRM')}
				</Button>
			</DialogActions>
		</>
	);
}
